import {
  Activity,
  Globe,
  Bell,
  BarChart3,
  Thermometer,
  Settings,
  ArrowRight,
  LogIn,
} from "lucide-react";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { dataStore365 } from "../../data/mock";

const iconMap = {
  Activity,
  Globe,
  Bell,
  BarChart3,
  Thermometer,
  Settings,
};

export const DataStore365Section = () => {
  return (
    <section
      id="datastore365"
      className="relative py-28 lg:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 bg-[#050510]" />
      {/* Decorative glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle,rgba(0,220,255,0.04)_0%,transparent_60%)]" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[radial-gradient(circle,rgba(0,119,255,0.03)_0%,transparent_65%)]" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        {/* Header with logo */}
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-10 lg:gap-20 mb-20">
          {/* Text content */}
          <div className="flex-1 space-y-6">
            <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full border border-cyan-400/20 bg-cyan-400/[0.05]">
              <span className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse" />
              <span className="text-xs font-semibold text-cyan-400 tracking-widest uppercase">
                Producto Destacado
              </span>
            </div>
          {/* DataStore365 Logo */}
          <div className="flex-shrink-0 relative">
            <div className="relative w-80 h-15 lg:w-96 lg:h-15 flex items-center justify-center">
              <img
                src={dataStore365.logo}
                alt="DataStore365"      
              />
            </div>
          </div>
            <h2 className="text-3xl md:text-4xl lg:text-[2.75rem] font-bold text-white leading-tight">
              Monitoreo inteligente{" "}
              <span className="text-white/30">para tu negocio</span>
            </h2>

            <p className="text-lg text-white/40 leading-relaxed max-w-xl">
              {dataStore365.description}
            </p>

            <div className="flex flex-wrap gap-4 pt-2">
              <a
                href={dataStore365.loginUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
              </a>
              <Button
                onClick={() =>
                  document
                    .querySelector("#contacto")
                    ?.scrollIntoView({ behavior: "smooth" })
                }
                variant="outline"
                className="border-cyan-400 text-white hover:bg-cyan-500 hover:border-white/20 px-8 h-12 text-base rounded-lg transition-colors duration-300 group"
              >
                Solicitar información
                <ArrowRight
                  size={16}
                  className="ml-2 group-hover:translate-x-1 transition-transform duration-300"
                />
              </Button>
            </div>
          </div>

          
        </div>

        {/* Features grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {dataStore365.features.map((feature, i) => {
            const Icon = iconMap[feature.icon];
            return (
              <Card
                key={i}
                className="group bg-white/[0.015] border-white/[0.05] hover:border-cyan-400/20 p-6 rounded-xl transition-all duration-500 overflow-hidden relative"
              >
                <div className="absolute -top-16 -right-16 w-32 h-32 bg-[radial-gradient(circle,rgba(0,220,255,0.06)_0%,transparent_70%)] opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                <div className="relative">
                  <div className="w-11 h-11 rounded-lg bg-cyan-400/[0.08] border border-cyan-400/15 flex items-center justify-center mb-4 group-hover:bg-cyan-400/[0.12] transition-colors duration-500">
                    <Icon size={20} className="text-cyan-400" />
                  </div>
                  <h3 className="text-base font-semibold text-white mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-white/30 leading-relaxed">
                    {feature.desc}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA bar */}
        <div className="mt-14 p-6 lg:p-8 rounded-2xl bg-cyan-400/[0.03] border border-cyan-400/[0.08] flex flex-col sm:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-lg font-semibold text-white">
              ¿Ya tenes un dispositivo DataStore365?
            </h3>
            <p className="text-sm text-white/35 mt-1">
              Ingresa a tu panel de control para monitorear tus dispositivos en tiempo real y acceder a todas las funcionalidades avanzadas que DataStore365 tiene para ofrecer.
            </p>
          </div>
          <a
            href={dataStore365.loginUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex-shrink-0"
          >
            <Button className="bg-cyan-500 hover:bg-cyan-600 text-white px-6 h-11 rounded-lg transition-colors duration-300 whitespace-nowrap">
              Acceder a DataStore365
              <ArrowRight size={16} className="ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};
